<template>
  <v-card>
    <v-card-title class="body-2 font-weight-bold">
      FILTER
    </v-card-title>
    <v-row>
      <v-col cols="12" md="4">
        <app-cb
          cb_type="profile"
          cb_url="apiListProfile"
          cb_url_parameter="profile_actived=Y"
          cb_title="Obligie"
          cb_id="cert_obligie"
          cb_desc="cert_obligiedesc"
          cb_rules="Please fill Obligie"
          cb_desc_readonly="readonly"
          cb_items_id="profile_id"
          cb_items_desc="profile_name"
          class="ml-2 mr-0"
          :cb_value_id="this.form.policy_obligie"
          :cb_value_desc="this.form.policy_obligiedesc"
          @clicked="GetObligie"
        >
        </app-cb>
      </v-col>
      <v-col cols="12" md="4" class="mt-n3">
        <v-text-field
          v-model="form.policy_certificateno"
          label="Certificate No"
          class="mx-2"
          prepend-inner-icon="mdi-ticket-confirmation"
        />
      </v-col>
      <v-col cols="12" md="4" class="mt-n3">
        <v-text-field
          v-model="form.policy_insured"
          ref="insured"
          class="mx-2"
          label="Project Name"
          prepend-inner-icon="mdi-account-circle"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          depressed
          small
          color="fourth"
          @click="CheckData()"
          class="ml-2 mb-2"
        >
          CEK DATA
        </v-btn>
        <v-btn
          depressed
          small
          color="secondary"
          @click="ClearForm()"
          class="ml-2 mb-2"
        >
          CLEAR FORM
        </v-btn>
      </v-col>
    </v-row>
    <v-progress-linear
      indeterminate
      color="primary"
      v-if="loading.detail"
    ></v-progress-linear>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
      class="mx-2"
    ></v-text-field>

    <v-data-table
      :headers="headers"
      :items="items.policy"
      :search="search"
      item-key="policy_ano"
      class="elevation-1"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-page-first',
        lastIcon: 'mdi-page-last',
        prevIcon: 'mdi-chevron-left',
        nextIcon: 'mdi-chevron-right'
      }"
      dense
      :loading="loading.list"
      loading-text="Loading... Please wait"
    >
      <template v-slot:item.fastflow_fieldvaluedesc_7="{ item }">
        {{ $functions.FormatDateIndo(item.fastflow_fieldvaluedesc_7) }} s/d
        {{ $functions.FormatDateIndo(item.fastflow_fieldvaluedesc_8) }}
      </template>
      <template v-slot:item.fastflow_sdate="{ item }">
        {{ $functions.FormatDateIndo(item.fastflow_sdate) }} s/d
        {{ $functions.FormatDateIndo(item.fastflow_edate) }}
      </template>
      <template v-slot:item.fastflow_fieldvaluedesc_6="{ item }">
        {{ $functions.FormatNumber(item.fastflow_fieldvaluedesc_6) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: ["fastflow_id"],
  data: () => ({
    form: {
      policy_obligie: "",
      policy_obligiedesc: "",
      policy_certificateno: "",
      policy_insured: ""
    },
    items: {
      policy: []
    },
    search: "",
    headers: [
      { text: "Obligie", value: "fastflow_profile_holderid" },
      { text: "Principle", value: "fastflow_insured" },
      { text: "Type Of Project", value: "fastflow_fieldvaluedesc_1" },
      { text: "Certificate No", value: "fastflow_id" },
      { text: "Project Name", value: "fastflow_fieldvaluedesc_2" },
      { text: "Project Location", value: "fastflow_fieldvaluedesc_3" },
      { text: "CEO Name", value: "fastflow_fieldvaluedesc_4" },
      { text: "Commission Name", value: "fastflow_fieldvaluedesc_5" },
      {
        text: "Contract Value",
        value: "fastflow_fieldvaluedesc_6",
        align: "end"
      },
      {
        text: "Period Contract",
        value: "fastflow_fieldvaluedesc_7",
        align: "end"
      },
      { text: "Period Policy", value: "fastflow_sdate", align: "end" }
    ],
    loading: {
      detail: false,
      list: false
    }
  }),
  watch: {
    fastflow_id: {
      handler: "updateCertificateNo",
      immediate: true
    }
  },
  methods: {
    updateCertificateNo() {
      this.form.policy_certificateno = this.fastflow_id;
      if (this.fastflow_id != "") {
        this.CheckData();
      }
    },
    CheckData() {
      this.loading.detail = true;
      let formData = new FormData();
      formData.append("fastflow_profile_holderid", this.form.policy_obligie);
      formData.append("fastflow_id", this.form.policy_certificateno);
      formData.append("fastflow_insured", this.form.policy_insured);
      formData.append("fastflow_toc", "6401");
      this.$axios
        .post(this.$functions.SafeURL("apiListFastflowSurety", ``), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              this.items.policy = feedback;
            } else {
              this.SnackBar(true, "error", feedback[0].feedback, 0);
            }
          } else {
            this.items.policy = feedback;
          }
          this.loading.detail = false;
        })
        .catch(e => {
          this.loading.detail = false;
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    GetObligie(value) {
      if (value !== undefined) {
        let splits = this.$functions.Split(value, "|");
        let profileid = splits[0];
        let profiledesc = splits[1];
        this.form.cert_obligie = profileid;
        this.form.cert_obligiedesc = profiledesc;
      }
    },
    ClearForm() {
      this.form.policy_policyno = "";
      this.form.policy_certificateno = "";
      this.form.insured = "";
    }
  }
};
</script>
